import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import cs from 'classnames';
import Styles from '../../../Styles.module.scss';
import { getBrandDomain } from '../../../../../common/utils/getBrandDomain';

export default function Login() {
    const brandDomain = getBrandDomain();
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={Styles.CommandCard}>
            <div className={Styles.CommandHeader} onClick={() => setExpanded(!expanded)}>
                <div>
                    <span className={Styles.CommandName}>modelpark login</span>
                    <span className={Styles.CommandSummary}>Authenticate with ModelPark</span>
                </div>
                <DownOutlined className={cs(Styles.CommandExpandIcon, { [Styles.expanded]: expanded })} />
            </div>

            {expanded && (
                <div className={Styles.CommandBody}>
                    <p className={Styles.CommandDescription}>
                        Authenticate with ModelPark and save credentials to <code>~/.modelpark/config.json</code>.
                        You can use interactive login, provide a token, or use an environment variable.
                        Plain <code>modelpark login</code> (email and password) now saves a personal API token for this
                        computer. You can see it under Settings → API Tokens, and your session no longer expires after 7 days.
                    </p>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Options</div>
                        <table className={Styles.OptionsTable}>
                            <thead>
                                <tr>
                                    <th>Flag</th>
                                    <th>Short</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>--token</td>
                                    <td>-t</td>
                                    <td>Authentication token from dashboard</td>
                                </tr>
                                <tr>
                                    <td>--email</td>
                                    <td>-e</td>
                                    <td>Email address (prompts for password)</td>
                                </tr>
                                <tr>
                                    <td>--server</td>
                                    <td>-</td>
                                    <td>{`Server URL (default: https://${brandDomain})`}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Authentication Priority</div>
                        <ol style={{ margin: 0, paddingLeft: 20, fontSize: 14, opacity: 0.7 }}>
                            <li><code>MODELPARK_TOKEN</code> environment variable</li>
                            <li><code>--token</code> flag</li>
                            <li>Interactive email/password prompt</li>
                        </ol>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Examples</div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Interactive login (prompts for email and password)</code>
                            <br />
                            <code>modelpark login</code>
                        </div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Login with token from dashboard</code>
                            <br />
                            <code>modelpark login --token YOUR_TOKEN</code>
                        </div>
                        <div className={Styles.CodeBlock} style={{ marginBottom: 8 }}>
                            <code># Login via environment variable</code>
                            <br />
                            <code>MODELPARK_TOKEN=xxx modelpark login</code>
                        </div>
                        <div className={Styles.CodeBlock}>
                            <code># Login with email (prompts for password only)</code>
                            <br />
                            <code>modelpark login --email user@example.com</code>
                        </div>
                    </div>

                    <div className={Styles.CommandExample}>
                        <div className={Styles.CommandExampleLabel}>Getting a Token</div>
                        <ol style={{ margin: 0, paddingLeft: 20, fontSize: 14, opacity: 0.7 }}>
                            <li>Go to <a href={`https://${brandDomain}`} target="_blank" rel="noopener noreferrer" style={{ color: '#4abe2f' }}>{brandDomain}</a> and log in</li>
                            <li>Navigate to <strong>Settings</strong> → <strong>API Tokens</strong></li>
                            <li>Click <strong>Create Token</strong></li>
                            <li>Copy the ready-made <code>modelpark login</code> command and run it</li>
                        </ol>
                    </div>
                </div>
            )}
        </div>
    );
}
